import { Component, type ErrorInfo, type ReactNode } from 'react';
import { PrimaryButton } from './components';

/**
 * Страховка на случай сломанного экрана.
 *
 * Содержание правит Елена, и однажды она обязательно опубликует что-то,
 * чего код не ждёт. Без этой границы любая такая ошибка гасит приложение
 * целиком: женщина видит белый экран и не понимает, что произошло —
 * ни выйти, ни вернуться.
 *
 * Здесь она видит короткое объяснение и кнопку начать заново.
 */
export class ErrorBoundary extends Component<
  { children: ReactNode },
  { failed: boolean }
> {
  override state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    // Пишем в консоль, а не молчим: без следа такую поломку не найти.
    console.error('Экран не отрисовался', error, info.componentStack);
  }

  override render(): ReactNode {
    if (!this.state.failed) return this.props.children;

    return (
      <main className="screen">
        <div className="stack">
          <h1>Экран не открылся</h1>
          <p>Это наша ошибка, а не ваша. Данные и ответы сохранены.</p>
          <p>Попробуйте вернуться к началу — остальное приложение работает.</p>
        </div>
        <div className="stack actions">
          <PrimaryButton onClick={() => window.location.reload()}>Начать заново</PrimaryButton>
        </div>
      </main>
    );
  }
}
